import React, { useState, useEffect } from 'react';
import { supabase } from '../../api/supabase';
import { useAuth } from '../../context/AuthContext';

const FIELDS = [
  { key: 'name',       label: 'Company Name',       full: true },
  { key: 'address1',   label: 'Address Line 1',      full: true },
  { key: 'address2',   label: 'Address Line 2',      full: true },
  { key: 'phone1',     label: 'Phone 1' },
  { key: 'phone2',     label: 'Phone 2' },
  { key: 'email1',     label: 'Email 1' },
  { key: 'email2',     label: 'Email 2' },
  { key: 'visa_phone', label: 'Visa Phone' },
  { key: 'visa_email', label: 'Visa Email', full: true },
];

export default function CompanySettings() {
  const { user } = useAuth();
  const username = user?.email?.split('@')[0] || 'unknown';
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    supabase.from('app_settings').select('value').eq('key', 'company').single()
      .then(({ data }) => { if (data) setForm(data.value || {}); setLoading(false); });
  }, []);

  const set = (k, v) => { setForm(f => ({ ...f, [k]: v })); setSaved(false); };

  async function handleSave() {
    setSaving(true); setError('');
    const { error: e } = await supabase.from('app_settings').upsert({
      key: 'company', value: form,
      updated_by: username, updated_at: new Date().toISOString(),
    }, { onConflict: 'key' });
    setSaving(false);
    if (e) { setError(e.message); } else { setSaved(true); }
  }

  if (loading) return <div className="spinner" style={{ padding: 40 }} />;

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">Company Details</div>
          <div className="page-subtitle">Printed on all invoices, pro formas, and quotations</div>
        </div>
        <button className="btn btn-primary" onClick={handleSave} disabled={saving}>
          {saving ? 'Saving…' : saved ? 'Saved' : 'Save Changes'}
        </button>
      </div>

      {error && <div style={{ color: 'var(--danger)', marginBottom: 16 }}>{error}</div>}

      <div className="card" style={{ maxWidth: 640 }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          {FIELDS.map(f => (
            <div key={f.key} className="form-group" style={{ margin: 0, gridColumn: f.full ? 'span 2' : 'span 1' }}>
              <label className="form-label">{f.label}</label>
              <input className="form-input" value={form[f.key] || ''} onChange={e => set(f.key, e.target.value)} />
            </div>
          ))}
        </div>

        <div style={{ marginTop: 24, padding: 16, background: 'var(--bg)', borderRadius: 8, fontSize: 12, color: 'var(--text-muted)' }}>
          <div style={{ fontWeight: 600, marginBottom: 6 }}>Footer preview</div>
          <div style={{ fontWeight: 700, fontSize: 13, color: 'var(--text)', marginBottom: 2 }}>{form.name}</div>
          <div>{form.address1}{form.address2 ? ` | ${form.address2}` : ''}</div>
          <div>{[form.phone1, form.phone2].filter(Boolean).join(' / ')}{form.email1 ? ` | ${[form.email1, form.email2].filter(Boolean).join(' / ')}` : ''}</div>
          <div style={{ marginTop: 4, fontWeight: 600 }}>Visa: {[form.visa_phone, form.visa_email].filter(Boolean).join(' | ')}</div>
        </div>
      </div>
    </div>
  );
}
